import { RequestStatus } from '@upright/ui/api/common/types';
import { useTargetsLensContext } from '@upright/ui/common/upright/core/impact-lenses/targets/common/use-targets-lens-context';
import {
  getTargetInfoBoxDataWithBoundsForSelection,
  mergeTargets,
} from '@upright/ui/common/upright/core/impact-lenses/targets/common/utils';
import { TargetInfoBox } from '@upright/ui/common/upright/core/impact-lenses/targets/info-boxes/target-info-box';
import { useCarouselContext, useCarouselLayout } from '../../../impact-lens-profile/context';
import { OnlySbtiTargetsInfoBox } from './only-sbti-targets-info-box';
import { ModelEntityType } from '@upright/common/model/input/types';

export function TargetsInfoBoxes() {
  const { lensIndex, previousLensIndex, data } = useCarouselContext();
  const ctx = useTargetsLensContext();
  const baseLayout = useCarouselLayout();

  const loadingStatus = ctx?.data.loadingStatus;
  if (loadingStatus === RequestStatus.LOADING) {
    return <></>;
  }

  const entityTargets = ctx?.data.targets;
  const sbtiTargets = ctx?.data.sbtiTargets;
  const allTargets = mergeTargets(entityTargets, sbtiTargets);

  const noEntityTargets = !entityTargets || entityTargets.length === 0;
  const noTargets = !allTargets || allTargets.length === 0;

  if (noTargets) {
    return <></>;
  }

  const companyId = data.entity?.type === ModelEntityType.COMPANY ? data.entity.id : undefined;

  const boxData = getTargetInfoBoxDataWithBoundsForSelection(
    baseLayout,
    allTargets,
    lensIndex,
    previousLensIndex,
    ctx?.selection,
  );

  const boxes = boxData.map(d => {
    // TODO: better idea to define key by id
    const key = d.data.map(item => item.text).join('');
    return (
      <TargetInfoBox
        key={key}
        id={key}
        targets={d.data}
        x={d.bounds.x1}
        y={d.bounds.y1}
        width={d.bounds.width}
        height={d.bounds.height}
        entityName={ctx?.data.entity?.name}
      />
    );
  });

  return (
    <>
      <div>{boxes}</div>
      {noEntityTargets && !!sbtiTargets?.length && companyId && <OnlySbtiTargetsInfoBox companyId={companyId} />}
    </>
  );
}
